export default __webpack_public_path__ + "static/media/employeedir.6716dcea.png";